import React, { useState } from 'react';
import { List, Input, Button, Tag, Modal, Rate, message } from 'antd';
import { SearchOutlined, FilterOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Search } = Input;

const OrderList = () => {
    const [orders, setOrders] = useState([
        { id: 1, name: 'Girls Pink Moana Printed Dress', size: 'S', qty: 1, price: 80.00, status: 'Delivered', image: 'path_to_dress_image.jpg' },
        { id: 2, name: 'Women Textured Handheld Bag', size: 'Regular', qty: 1, price: 80.00, status: 'In Process', image: 'path_to_bag_image.jpg' },
        { id: 3, name: 'Tailored Cotton Casual Shirt', size: 'M', qty: 1, price: 40.00, status: 'In Process', image: 'path_to_shirt_image.jpg' },
    ]);

    const [isReviewModalVisible, setIsReviewModalVisible] = useState(false);
    const [currentReviewOrder, setCurrentReviewOrder] = useState(null);
    const [reviewRating, setReviewRating] = useState(0);

    const handleCancelOrder = (orderId) => {
        setOrders(orders.map(order =>
            order.id === orderId ? { ...order, status: 'Cancelled' } : order
        ));
        message.success('Order cancelled successfully');
    };

    const handleWriteReview = (order) => {
        setCurrentReviewOrder(order);
        setIsReviewModalVisible(true);
    };

    const handleReviewSubmit = () => {
        // Here you would typically send the review to your backend
        message.success('Review submitted successfully');
        setIsReviewModalVisible(false);
        setReviewRating(0);
    };

    const renderOrderActions = (order) => {
        if (order.status === 'Delivered') {
            return [
                <Button key="view" type="default" onClick={() => console.log('View Order', order.id)}>View Order</Button>,
                <Button key="review" type="primary" onClick={() => handleWriteReview(order)}>Write A Review</Button>
            ];
        } else if (order.status === 'In Process') {
            return [
                <Button key="view" type="default" onClick={() => console.log('View Order', order.id)}>View Order</Button>,
                <Button key="cancel" type="danger" onClick={() => handleCancelOrder(order.id)}>Cancel Order</Button>
            ];
        } else {
            return [
                <Button key="view" type="default" onClick={() => console.log('View Order', order.id)}>View Order</Button>
            ];
        }
    };

    return (
        <div style={{ maxWidth: 800, margin: '0 auto', padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
                <Search
                    placeholder="Search orders"
                    onSearch={value => console.log(value)}
                    style={{ width: 300 }}
                    prefix={<SearchOutlined />}
                />
                <Button icon={<FilterOutlined />}>Filter</Button>
            </div>

            <List
                itemLayout="horizontal"
                dataSource={orders}
                renderItem={order => (
                    <List.Item
                        actions={renderOrderActions(order)}
                    >
                        <List.Item.Meta
                            avatar={<img src={order.image} alt={order.name} style={{ width: 80, height: 80, objectFit: 'cover' }} />}
                            title={<Link to="product/">{order.name}</Link>}
                            description={
                                <>
                                    <p>Size: {order.size}</p>
                                    <p>Qty: {order.qty}</p>
                                    <Tag color={order.status === 'Delivered' ? 'green' : order.status === 'In Process' ? 'blue' : 'red'}>
                                        {order.status}
                                    </Tag>
                                </>
                            }
                        />
                        <div style={{ fontWeight: 'bold' }}>${order.price.toFixed(2)}</div>
                    </List.Item>
                )}
            />

            <Modal
                title="Write a Review"
                open={isReviewModalVisible}
                onOk={handleReviewSubmit}
                onCancel={() => setIsReviewModalVisible(false)}
            >
                <p>How would you rate {currentReviewOrder?.name}?</p>
                <Rate value={reviewRating} onChange={setReviewRating} />
                <Input.TextArea rows={4} placeholder="Write your review here" style={{ marginTop: 20 }} />
            </Modal>
        </div>
    );
};

export default OrderList;